// MIT License

// Copyright (c) [year] [fullname]

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import React from "react";
import "./CorouselStyle.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// import Achievement1 from "../images/aboutuspage/Achievement1.webp"
import Achievement2 from "../images/aboutuspage/Achievement2.webp";
import Achievement3 from "../images/aboutuspage/Achievement3.webp";
import Achievement4 from "../images/aboutuspage/Achievement4.webp";
import Achievement5 from "../images/aboutuspage/Achievement5.webp";
import Achievement6 from "../images/aboutuspage/Achievement6.webp";
import Achievement7 from "../images/aboutuspage/Achievement7.webp";
import Achievement8 from "../images/aboutuspage/Achievement8.webp";
import Achievement9 from "../images/aboutuspage/Achievement9.webp";
import Achievement10 from "../images/aboutuspage/Achievement10.webp";
import Achievement11 from "../images/aboutuspage/Achievement11.webp";
import Achievement12 from "../images/aboutuspage/Achievement12.webp";
import Achievement13 from "../images/aboutuspage/Achievement13.webp";
import Achievement14 from "../images/aboutuspage/Achievement14.webp";
import Achievement15 from "../images/aboutuspage/Achievement15.webp";
import Achievement16 from "../images/aboutuspage/Achievement16.webp";
import Acquisition1 from "../images/aboutuspage/clientacquisition1.webp"
import Acquisition2 from "../images/aboutuspage/clientacquisition2.webp"
// import { CarouselProps } from 'react-responsive-carousel'
const MyCorousel = () => {
  return (
    <div className="achievementcarouseldiv">
      <Carousel
        infiniteLoop
        autoPlay
        showThumbs="false"
        emulateTouch
        interval="2500"
        showStatus="false"
        showIndicators="false"
      >
        <div>
          <img src={Acquisition1} alt="Image1" className="img1" />
        </div>
        <div>
          <img src={Acquisition2} alt="Image1" className="img1" />
        </div>
        <div>
          <img src={Achievement16} alt="Image1" className="img1" />
        </div>
        <div>
          <img src={Achievement2} alt="Image2" className="img1" />
          {/* <p className="legend">Legend 2</p> */}
        </div>
        <div>
          <img src={Achievement3} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement4} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement5} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement6} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement7} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement8} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement9} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement10} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement11} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement12} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement13} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement14} alt="Image3" className="img1" />
        </div>
        <div>
          <img src={Achievement15} alt="Image3" className="img1" />
        </div>
      </Carousel>
    </div>
  );
};

export default MyCorousel;
